define('bizzabo/views/ExternalEventsListView',[
    'jquery',
    'backbone',
    'Handlebars'
], function(
    $,
    Backbone,
    Handlebars
    ) {

    var ExternalEventsListView = Backbone.View.extend({

        tagName: 'ul',

        initialize: function() {
            this.itemViews = [];
            this.listenTo(this.model, 'reset change', this.render);
            this.listenTo(this.model, 'add', this.addItemView);
        },

        remove: function() {
            this.removeAllItemViews();
            this.$el.remove();
        },

        render: function() {
            this.removeAllItemViews();
            this.$el.empty();
            this.model.each(function(event) {
                this.addItemView(event);
            }, this);
            return this;
        },

        addItemView: function(event) {
            var itemView = new ExternalEventsListItemView({
                model: event
            });
            this.itemViews.push(itemView);
            this.$el.append(itemView.render().$el);
        },

        removeAllItemViews: function() {
            _.each(this.itemViews, function(itemView) {
                itemView.remove();
            });
            this.itemViews = [];
        }

    });

    var ExternalEventsListItemView = Backbone.View.extend({

        tagName: 'li',

        events: {
            'click a.editButton': 'connectEventClicked'
        },

        initialize: function() {
            this.listenTo(this.model, 'change', this.render);
        },

        render: function() {
            var source = '<span><strong>{{name}}</strong> ({{eventDates this}})</span><a class="button primary editButton">Connect</a>';
            var html = Handlebars.compile(source)(this.model.toJSON());
            this.$el.html(html);
            return this;
        },

        connectEventClicked: function() {
            Backbone.trigger('connect-event-clicked', this.model);
        }

    });

    return ExternalEventsListView;

});
